import { StyleSheet } from "react-native";
import { mainScreen } from "../Styles/mainScreen";

export default StyleSheet.create({
  ...mainScreen,
  iconEdit: {
    position: "absolute",

    right: 15,
  },
  botao: {
    marginVertical: 10,
    height: 42,
    backgroundColor: "#AA0000",
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  botaoText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#fff",
  },
});
